/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * 歳出科目のレベル（会計区分/款/項/目）
 */
export type MasterFlatListItemLevel =
  (typeof MasterFlatListItemLevel)[keyof typeof MasterFlatListItemLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MasterFlatListItemLevel = {
  accounting_type: 'accounting_type',
  kan: 'kan',
  ko: 'ko',
  moku: 'moku',
} as const;
